import { connect } from 'react-redux';
import { Product } from '~/Api/Product';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { logGoogleTagManagerGroupProductsRemove } from '~/GoogleTagManager';
import { removeFromGroup, State as GroupProductState } from '~/GroupProduct';
import { ThunkDispatch } from '~/Store';
import DeleteModal from '~/UI/DeleteModal/DeleteModal';

interface OwnProps {
	group: UserProductGroup;
	product: Product;
	onConfirm?(): Promise<void> | void;
	onSuccess?(): void;
}

const mapStateToProps = ({ groupProduct }: { groupProduct: GroupProductState }, { group, product }: OwnProps) => ({
	isFetching: groupProduct.removeRequest !== null,
	title: `Remove product: ${product.brandName} from ${group.name}`,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any>, { group, product, onConfirm, onSuccess }: OwnProps) => ({
	onConfirm: async () => {
		if (onConfirm !== undefined) {
			await onConfirm();
		}

		try {
			await dispatch(removeFromGroup(group.id, [product]));
			logGoogleTagManagerGroupProductsRemove(group.id, [product]);
			if (onSuccess !== undefined) {
				onSuccess();
			}
		} catch (error) {
			dispatch(handleError(error));
		}
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
